'use client';

import { c as _c } from "react/compiler-runtime";
import { Body, Caption, H3, InputOTP, InputOTPGroup, InputOTPSlot } from '@material-bank/mb3-components';
import { useEffect, useState } from 'react';
import { useTranslations } from '@material-bank/i18n';
const RESEND_COUNTDOWN_SECONDS = 60;
type OtpStepProps = {
  email: string;
  isLoading: boolean;
  error: string | null;
  onSubmit: (otp: string) => void;
  onResend: () => void;
};
export function OtpStep(t0) {
  const $ = _c(44);
  const {
    email,
    isLoading,
    error,
    onSubmit,
    onResend
  } = t0;
  const t = useTranslations("authentication.otpStep");
  const [otp, setOtp] = useState("");
  const [countdown, setCountdown] = useState(RESEND_COUNTDOWN_SECONDS);
  let t1;
  let t2;
  if ($[0] !== countdown) {
    t1 = () => {
      if (countdown <= 0) {
        return;
      }
      const timer = setTimeout(() => setCountdown(_temp), 1000);
      return () => clearTimeout(timer);
    };
    t2 = [countdown];
    $[0] = countdown;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  let t3;
  if ($[3] !== onSubmit) {
    t3 = function handleComplete(value) {
      onSubmit(value);
    };
    $[3] = onSubmit;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const handleComplete = t3;
  let t4;
  if ($[5] !== onResend) {
    t4 = function handleResend() {
      setOtp("");
      setCountdown(RESEND_COUNTDOWN_SECONDS);
      onResend();
    };
    $[5] = onResend;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const handleResend = t4;
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = function pasteTransformer(pasted) {
      return pasted.replace(/\D/g, "").slice(0, 6);
    };
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  const pasteTransformer = t5;
  let t6;
  if ($[8] !== t) {
    t6 = t("heading");
    $[8] = t;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t6) {
    t7 = <H3>{t6}</H3>;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== email || $[13] !== t) {
    t8 = t("subheading", {
      email
    });
    $[12] = email;
    $[13] = t;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== t8) {
    t9 = <Body variant="small" className="text-gray-500">{t8}</Body>;
    $[15] = t8;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== t) {
    t10 = t("spamFolder");
    $[17] = t;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== t10) {
    t11 = <Body variant="small" className="text-gray-500">{t10}</Body>;
    $[19] = t10;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  let t12;
  if ($[21] !== t11 || $[22] !== t7 || $[23] !== t9) {
    t12 = <div className="flex flex-col gap-2">{t7}{t9}{t11}</div>;
    $[21] = t11;
    $[22] = t7;
    $[23] = t9;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  let t13;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <InputOTPGroup><InputOTPSlot index={0} /><InputOTPSlot index={1} /><InputOTPSlot index={2} /><InputOTPSlot index={3} /><InputOTPSlot index={4} /><InputOTPSlot index={5} /></InputOTPGroup>;
    $[25] = t13;
  } else {
    t13 = $[25];
  }
  let t14;
  if ($[26] !== handleComplete || $[27] !== isLoading || $[28] !== otp) {
    t14 = <InputOTP maxLength={6} value={otp} onChange={setOtp} onComplete={handleComplete} pasteTransformer={pasteTransformer} disabled={isLoading} autoComplete="one-time-code">{t13}</InputOTP>;
    $[26] = handleComplete;
    $[27] = isLoading;
    $[28] = otp;
    $[29] = t14;
  } else {
    t14 = $[29];
  }
  let t15;
  if ($[30] !== error) {
    t15 = error && <Body variant="small" className="text-red-600">{error}</Body>;
    $[30] = error;
    $[31] = t15;
  } else {
    t15 = $[31];
  }
  let t16;
  if ($[32] !== countdown || $[33] !== handleResend || $[34] !== isLoading || $[35] !== t) {
    t16 = countdown > 0 ? <Caption className="text-gray-500">{t("resendCountdown", {
        countdown
      })}</Caption> : <Caption className="text-gray-500"><button type="button" onClick={handleResend} disabled={isLoading} className="text-gray-900 underline hover:no-underline disabled:opacity-50">{t("resendButton")}</button></Caption>;
    $[32] = countdown;
    $[33] = handleResend;
    $[34] = isLoading;
    $[35] = t;
    $[36] = t16;
  } else {
    t16 = $[36];
  }
  let t17;
  if ($[37] !== t14 || $[38] !== t15 || $[39] !== t16) {
    t17 = <div className="flex flex-col gap-3">{t14}{t15}{t16}</div>;
    $[37] = t14;
    $[38] = t15;
    $[39] = t16;
    $[40] = t17;
  } else {
    t17 = $[40];
  }
  let t18;
  if ($[41] !== t12 || $[42] !== t17) {
    t18 = <div className="flex flex-col gap-6">{t12}{t17}</div>;
    $[41] = t12;
    $[42] = t17;
    $[43] = t18;
  } else {
    t18 = $[43];
  }
  return t18;
}
function _temp(c) {
  return c - 1;
}